import { useTranslation } from 'react-i18next';
import { Boton } from '../componentes/ui/basicos';
import { FormularioDeClave } from '../componentes/FormularioDeClave';
import { useSesion } from '../sesion/ProveedorDeSesion';

/**
 * Elegir la propia clave, antes que nada.
 *
 * Se llega acá entrando con una clave provisoria. No hay menú ni comercio hasta cambiarla: la
 * única salida es elegir una, o salir. La provisoria va en «clave actual», y la pantalla lo dice.
 */
export function ElegirClave(): React.ReactElement {
  const { t } = useTranslation();
  const { perfil, salir } = useSesion();

  return (
    <div className="grid min-h-dvh place-items-center px-4">
      <div className="w-full max-w-md rounded-marco border border-borde bg-superficie p-6">
        <h1 className="mb-1 text-lg font-semibold tracking-tight">{t('clave.elegi')}</h1>
        <p className="mb-1 text-xs text-texto-tenue">{perfil?.correo ?? ''}</p>
        <p className="mb-5 text-sm text-texto-tenue">{t('clave.ayudaElegi')}</p>
        <FormularioDeClave
          onListo={() => {
            // Con el perfil recargado la marca se fue, y el armazón sigue solo.
          }}
        />
        <Boton tono="sutil" className="mt-4 w-full" onClick={() => void salir()}>
          {t('acciones.salir')}
        </Boton>
      </div>
    </div>
  );
}
